import { getInternalRumData } from './utils';
import { INTERNAL_INSTRUMENTATION_NAME } from './instrumentations/instrumentation.consts';
export const reportInternalEvent = (event, message) => {
    const internalInstrumentation = getInternalRumData(INTERNAL_INSTRUMENTATION_NAME);
    internalInstrumentation === null || internalInstrumentation === void 0 ? void 0 : internalInstrumentation.reportInternalEvent(event, message);
};
//# sourceMappingURL=internal-event-reporter.js.map